import { api } from './client'
import type { SpaceReviewItem, UpdateSpaceRequest, UUID } from '@/types/api'

export const spacesApi = {
  list: async (jobId: UUID): Promise<SpaceReviewItem[]> =>
    (await api.get(`/jobs/${jobId}/spaces`)).data,

  update: async (
    jobId: UUID,
    spaceId: UUID,
    body: UpdateSpaceRequest,
  ): Promise<SpaceReviewItem> =>
    (await api.patch(`/jobs/${jobId}/spaces/${spaceId}`, body)).data,
}
